import React from 'react';
import { Link, Navigate, Route, Routes } from 'react-router-dom';
import { usePortalAuth } from '../context/PortalAuthContext';
import PortalInvoices from '../pages/PortalInvoices';

export default function PortalLayout() {
  const { session, logout } = usePortalAuth();

  return (
    <div className="min-h-screen bg-slate-50 text-slate-900">
      <header className="bg-white border-b border-slate-200 px-6 py-4 flex items-center justify-between">
        <div>
          <p className="text-xs uppercase tracking-wide text-slate-500">Client portal</p>
          <p className="text-xl font-semibold">{session?.client_name || 'Client'}</p>
        </div>
        <nav className="flex items-center gap-4 text-sm">
          <Link to="/portal/invoices" className="text-indigo-600 font-medium">
            Invoices
          </Link>
          <button
            type="button"
            onClick={logout}
            className="rounded border border-slate-200 px-3 py-1.5 text-slate-600 hover:bg-slate-100"
          >
            Sign out
          </button>
        </nav>
      </header>
      <main className="max-w-5xl mx-auto w-full px-4 py-10">
        <Routes>
          <Route path="invoices" element={<PortalInvoices />} />
          <Route path="*" element={<Navigate to="/portal/invoices" replace />} />
        </Routes>
      </main>
    </div>
  );
}
